import { useTranslation } from 'react-i18next'
import { Box, Typography } from '@mui/material'
import { TwoFactorStatus } from '@/enums/two-factor-status.enum'

import TwoFactorDigitsComponent from '@/views/components/two-factor-digits/index.component'

type Props = {
  twoFactorVerified: TwoFactorStatus
}

const TwoFactorDisableComponent = ({ twoFactorVerified }: Props) => {
  const { t } = useTranslation()

  return (
    <Box mt={2}>
      <Typography className="fontWeight-500" paragraph>
        {t('twoFactor.disableTwoFactor')}
      </Typography>
      <Typography variant="body2">
        {t('twoFactor.disableTwoFactorDescription')}
      </Typography>
      <Box mt={4}>
        <TwoFactorDigitsComponent
          verificationCode
          twoFactorStatus={twoFactorVerified}
        />
      </Box>
    </Box>
  )
}

export default TwoFactorDisableComponent
